import { React } from '../../shared/react.js';
import { Icon } from '../../shared/icons.js';
import { useAppRuntime, useAppState } from '../../app/app.context.js';

export function RecentQueries() {
  const runtime = useAppRuntime();
  const state = useAppState();

  return (
    <section className="recent-queries" aria-labelledby="recent-query-title">
      <div className="recent-queries__heading">
        <h2 id="recent-query-title">Recent text queries</h2>
        <span>{state.history.length}</span>
      </div>
      <div className="recent-queries__list">
        {state.history.slice(0, 5).map((entry) => (
          <button className="recent-query" type="button" key={entry.id} onClick={() => void runtime.replayRecent(entry)}>
            <span className="recent-query__dot" aria-hidden="true"/>
            <span className="recent-query__copy"><strong>{entry.text}</strong></span>
            <Icon name="clock" size={13}/>
          </button>
        ))}
      </div>
      {state.branches.length > 0 && (
        <div className="query-branches" aria-label="Saved search branches">
          {state.branches.slice(0, 2).map((branch) => (
            <button type="button" key={branch.id} className={state.activeBranchId === branch.id ? 'is-active' : ''} onClick={() => void runtime.restoreBranch(branch.id)}>
              <Icon name="branch" size={13}/><span>{branch.name}</span>
            </button>
          ))}
        </div>
      )}
    </section>
  );
}
